module.exports = __webpack_public_path__ + "img/huoban6.8cdf498d.png";